// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"65c3de4a","453":"fa08229b"}[chunkId] + ".chunk.js";
};